module.exports = __webpack_public_path__ + "static/img/20250416.ed5c085.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20231116/20250416.jpg
// module id = Z5HM
// module chunks = 7